import { RootState } from '..';

export const selectorUserInfo = (state: RootState) => state.user.userInfo;
export const selectorDeliveryInfo = (state: RootState) => state.user.deliveryInfo;
